import { Button, Space } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

interface IProps {
    show?: boolean;
    onClickSaveOrder: () => void;
    onClickCancel: () => void;
    isSubmiting: boolean;
}

export default function AwardsListTableFooter({
    show = false,
    onClickSaveOrder,
    onClickCancel,
    isSubmiting,
}: IProps) {
    if (!show) {
        return null;
    }

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 12px',
                background: 'rgba(250, 140, 22, 0.08)',
                borderRadius: 8,
                border: '1px dashed #fa8c16',
                marginTop: 8,
                flexWrap: 'wrap',
                gap: 8,
            }}
        >
            <span style={{ fontSize: 13, color: '#d46b08', fontWeight: 500 }}>
                A ordem dos prêmios foi alterada!
            </span>
            <Space size={8}>
                <Button
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={onClickCancel}
                    disabled={isSubmiting}
                    style={{
                        borderRadius: 6,
                    }}
                >
                    Descartar
                </Button>
                <Button
                    size="small"
                    icon={<CheckOutlined />}
                    onClick={onClickSaveOrder}
                    disabled={isSubmiting}
                    loading={isSubmiting}
                    type="primary"
                    style={{
                        borderRadius: 6,
                        fontWeight: 600,
                    }}
                >
                    Salvar ordenação
                </Button>
            </Space>
        </div>
    );
}